import {Steps} from "../constants/constants";

interface Props {
    nextButton?: {
        text: string
        disabled: boolean
        onClick?: () => void
    },
    backButton?: {
        text: string
        disabled: boolean
        onClick?: () => void
    },
    hide: boolean
}

export const Buttons = (props: Props) => {

    const {nextButton, backButton, hide} = props

    if (hide || (!nextButton && !backButton)) {
        return null
    }

    return (
        <div className={'c-repair-buttons'}>
            {!!backButton &&
                <button disabled={backButton.disabled} className="c-repair-buttons__button c-repair-buttons__button--back" onClick={backButton.onClick}
                        type={'button'}>
                    {backButton.text}
                </button>
            }

            {!!nextButton &&
                <button disabled={nextButton.disabled} className="c-repair-buttons__button c-repair-buttons__button--submit" onClick={nextButton.onClick}>
                    {nextButton.text}
                </button>
            }
        </div>
    )
}